import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import ExoForm from '../../components/exo/ExoForm';
import { set } from 'date-fns';
import Loader from '../../components/special/Loader';
import { useState } from 'react';

export const NewProjectPreset = ({ projectId, onClose }) => {
  const config = useConfig();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  function handleSaveAsPreset(data) {
    setIsLoading(true);
    const reqData = { ...data, projectId };
    DBRequest({
      config,
      path: `project-presets`,
      method: API_POST(reqData),
      onResponse: () => {
        setIsLoading(false);
        onClose();
      },
    });
  }

  const fields = [
    {
      label: t('Icon'),
      type: 'icon',
      key: 'icon',
    },
    {
      label: t('Title'),
      type: 'text',
      key: 'title',
    },
    {
      type: 'divider',
      key: 'divider1',
    },
    {
      label: t('Include Billable Positions'),
      type: 'checkbox',
      key: 'includeBillablePositions',
      initialValue: '1',
    },
    {
      label: t('Include Calculative Hourly Rates'),
      type: 'checkbox',
      key: 'includeWagePresets',
      initialValue: '1',
    },
    {
      label: t('Include Tasks'),
      type: 'checkbox',
      key: 'includeTasks',
      initialValue: '1',
    },
  ];

  return (
    <>
      <ExoForm
        header={t('Save as preset')}
        fields={fields}
        onSubmit={handleSaveAsPreset}
      />
      <Loader active={isLoading} type="modern" />
    </>
  );
};
